import { SET_LANGUAGE } from '../constants';
// ##### 25-03-26 Komarov
export const setLanguage = language => dispatch => {
  dispatch({
    type: SET_LANGUAGE,
    payload: language,
  });
};
